<template>
  <fb-main-body>
    <div class="main">
      <iframe id="iframe" :src="url" class="iframe-box" frameborder="0"></iframe>

      <div class="lang-box">
        <span>{{$t('lang.选择语言')}}：</span>
        <nation-list :showText="false" :list="supportLangList" @click="lang = $event.value" :lang="mainLang" />
      </div>

      <el-button plain style="margin-top: 24px" @click="$router.push('/recipe-list')">{{$t('lang.结束预览')}}</el-button>

    </div>
  </fb-main-body>
</template>

<script>
import NationList from "../../components/nation/NationList";
export default {
  name: "Detail",
  components: {NationList},
  data() {
    return {
      supportLangList: [],
      lang: '',
      mainLang: ""
    }
  },
  created() {
    this.handleRecipeDetail();
  },
  methods: {
    handleRecipeDetail() {
      const vm = this;
      vm.$http.post(vm.$api.recipe.simulatDetail, vm.$qs.stringify(this.$route.query)).then(res => {
        vm.supportLangList = res.data.data.recipe.supportLangList;
        vm.lang = res.data.data.recipe.lang;
        this.mainLang = vm.lang;
      })
    }
  },
  computed: {
    url() {
      const {recipeEditionCode, number} = this.$route.query;
      // return `http://192.168.1.21:8080/recipe/?recipeEditionCode=${recipeEditionCode}&number=${number}&lang=${this.lang}`
      return  `recipe/index.html?recipeEditionCode=${recipeEditionCode}&number=${number}&lang=${this.lang}`
    }
  }
}
</script>

<style scoped>

.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  /*justify-content: center;*/
  height: 750px;
}

.lang-box {
  display: flex;
  align-items: center;
}

.iframe-box {
  width: 375px;
  height: 100%;
  margin-bottom: 24px;
  border: 3px solid #333333;
  border-radius: 4px;
}

</style>
